import React from "react"
import { ITimeTotals } from "../../../models"
import strings from "../../../localization/strings"
import _ from "lodash"
import { Paper } from "material-ui"
import BudgetTimeSummaryTable from "./BudgetTimeSummaryTable"
interface IProps {
    consolidatedTimecardTimeSummary: ITimeTotals
}

const ConsolidatedTimecardTimeSummary: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ marginTop: 10 }}>
            <Paper zDepth={1} style={{ padding: 15 }}>
                <span style={{ fontSize: 16, fontWeight: 600, marginLeft: 10 }}>{strings.Time_Summary}</span>
                <BudgetTimeSummaryTable
                    consolidatedTimecardTimeSummary={props.consolidatedTimecardTimeSummary}
                />
            </Paper>
        </div>
    )
}

export default ConsolidatedTimecardTimeSummary